<template>
    <Alert class="creative-x-alert" type="error">
        <p class="creative-x-error">
            We encountered an error while fetching CreativeX Options.<br />
            Please <span class="retry-link" @click="$emit('refetch')">try again</span>.
        </p>
    </Alert>
</template>

<script lang="ts">
export default {
    name: "CreativeXError",

    emits: ["refetch"]
};
</script>

<style scoped lang="scss">
.creative-x-alert {
    margin-top: 10px;
}
.creative-x-error {
    line-height: 16px;
    font-size: 12px;
}

.retry-link {
    color: var(--wpp-primary-color-500);
    cursor: pointer;

    &:hover {
        text-decoration: underline;
    }
}
</style>
